<template>
  <div class="container" v-if="empresa._id">
    <div class="content-box">
      <div class="element-wrapper pb-0">
        <div class="element-header">
          <div class="row">
            <div class="col-md-8 mr-auto">
              <h3 class>Novo Afiliado - {{empresa.name}}</h3>
            </div>
            <div class="col-auto">
              <b-button @click="voltar">Voltar</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="element-box">
      <form @submit.prevent="salvar">
        <div class="container">
          <div class="row">
            <div class="col-md-5">
              <div class="form-group"
                   :class="{'has-danger': errors.has('name')}">
                <label for="name">Nome do Recebedor</label>
                <input
                    id="name"
                    name="name"
                    v-validate="'required'"
                    v-model="afiliado.nome"
                    type="text"
                    class="form-control"
                />
                <div
                    v-if="errors.has('name')"
                    class="help-block form-text text-muted form-control-feedback"
                >{{errors.first('name')}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-3">
              <div class="form-group" :class="{'has-danger': errors.has('email')}">
                <label for="email">E-mail</label>
                <input
                    type="email"
                    name="email"
                    id="email"
                    v-model="afiliado.email"
                    v-validate="'required|email'"
                    class="form-control"
                />
                <div
                    v-if="errors.has('email')"
                    class="help-block form-text text-muted form-control-feedback"
                >{{errors.first('email')}}</div>
              </div>
            </div>
            <div class="form-group col-md-3">
              <div class="form-group" :class="{'has-danger': errors.has('telefoneFixo')}">
                <label for="fixo">Telefone</label>
                <input
                    type="tel"
                    name="fixo"
                    id="fixo"
                    v-model="afiliado.telefone"
                    v-validate="'required'"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    class="form-control"
                    aria-describedby="helpId"
                />
                <div
                    v-if="errors.has('telefoneFixo')"
                    class="help-block form-text text-muted form-control-feedback"
                >{{errors.first('telefoneFixo')}}</div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <b-button variant="primary" type="submit">
                Salvar
              </b-button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "AfiliadoForm",
  async created() {
    this.empresa = await axios.get(`/api/juridica/${this.$route.query.empresa}`)
        .then(response => response.data)
  },
  data: () => ({
    afiliado: {},
    empresa: null
  }),
  methods: {
    voltar() {
      window.history.back();
    },
    async salvar() {
      try {
        this.$store.dispatch('setLoading', true);

        this.afiliado.juridica = this.empresa._id

        if (this.afiliado._id) {
          await axios.put(`/api/afiliados/${this.afiliado._id}`, this.afiliado, {})
        } else {
          await axios.post('/api/afiliados', this.afiliado, {})
        }


        this.$router.push({name: 'Afiliado', query: {empresa: this.empresa._id}})
      } catch (e) {
        alert('Falha ao realizar save afiliado')
      } finally {
        this.$store.dispatch('setLoading', false);
      }
    }
  }
}

</script>
<style scoped>

</style>